// Central business identity — used across footer, contact, and legal/ads pages.
// Update the address with your registered business address before running paid ads.
export const BUSINESS = {
  name: "It's Genie Assist",
  email: "support@itsgenieassist.com",
  location: "United States",
  address: "Mailing address available on request",
  footer_blurb:
    "An independent customer service directory. We publish verified official support contacts sourced from brands' own websites so you can reach real help, fast.",
};
